import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';
import { LoyaltyQrService } from '@user/feature';

@Component({
  selector: 'sd-update-qr-button',
  templateUrl: './update-qr-button.component.html',
  styleUrls: ['./update-qr-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorIconComponent],
})
export class UpdateQrButtonComponent {
  private readonly loyaltyQrService = inject(LoyaltyQrService);
  protected readonly iconTypes = IconTypes;

  onUpdateQr(event: Event): void {
    event.stopPropagation();
    this.loyaltyQrService.loadLoyaltyQr();
  }
}
